module.exports = __webpack_public_path__ + "img/afesneww.a1e02312.png";